var e, r;
function t() {
  if (r) return e;
  r = 1;
  return e = class {
    constructor() {}
    sleep(e) {
      return new Promise(r => setTimeout(r, 1e3 * e));
    }
  };
}
export { t as __require };